import { Button, MenuItem, SelectChangeEvent, TextField } from "@mui/material";
import { Select } from "@mui/material";
import { Grid, Paper } from "@mui/material";
import React, { Suspense, useContext, useEffect, useMemo } from "react";

import { VEBEnrollmentSchema } from "../../../../../../../types/enrollment.types";
import {
	AuthContext,
	DependentsContext,
	EligibleDependentContext,
	EnrollmentContext,
	PaycheckContext,
	ThemeContext
} from "../../../../../../../contexts";
import { LazyCustomFormDialog, LazyPlanActions, VEBDisclaimer } from "../../../../../../shared";

import { Checkbox } from "@mui/material";
import { useState } from "react";
import { useCallback } from "react";

import "./criticalIllness.css";

import {
	CriticalIllnessAgeGroups,
	CriticalIllnessBenefitLevel,
	CriticalIllnessCoverageLevel,
	CriticalIllnessPlanCoverage,
	CriticalIllnessPlanDetails,
	PaycheckFrequency,
	VEBPlan
} from "../../../../../../../types/plan.types";
import { dollarize } from "../../../../../../../utils/commonFunctions/dollarize";
import calculateAge from "../../../../../../../utils/commonFunctions/age";
import { CustomSelectInput } from "../../../../../../shared/CustomInput";
import { VEBPlanFormProps } from "../../../../../../../types/components/enrollmentProps.types";
import { CustomFormDialogType } from "../../../../../../../types/components/dialogProps.types";

import { VEB_PLAN_NAMES } from "../../../../../../../constants/plan";

import { api } from "../../../../../../../utils/api";
import { getKemperCriticalIllnessEligibleDependents } from "../../../../../../../utils/commonFunctions/VEBEnrollment/eligibleDependents";
import { Member } from "../../../../../../../types/employee.types";
import CustomEnrollmentDisclaimerDialog from "../../../../../../shared/dialogs/customEnrollmentDisclaimerDialog/customEnrollmentDisclaimerDialog";
import { CustomDisclaimerDialogPropsType } from "../../../../../../../types/dialogProps.types";
import { DEPENDENCY_MESSAGE } from "../../../../../../../constants/VEB/dependencyMessage";

import { trackPromise } from "react-promise-tracker";

import { CRITICAL_ILLNESS_PREMIUM } from "../../../../../../../constants/vebPremiums/VEBPremiums";
import { calculateAgeGroup } from "../../../../../../../utils/commonFunctions/calculateAge";

import { VEBPlanCodes2024 } from "../../../../../../../constants/VEBPlanCodes/VEBPlanCodes2024";
import { useHistory, useLocation } from "react-router-dom";
import { VEBYearlyOpenAndCurrentEffectiveDate } from "../../../../../../../constants/VEBYearlyOpenAndCurrentDate";

const KemperStackFormCriticalIllness = ({
	onClose,
	VEBOpenEnrollment,
	getVEBEnrollmentInitData,
	vebBenefits
}: VEBPlanFormProps | any): JSX.Element => {
	const location = useLocation();
	const history = useHistory();
	const [eligiblityDialogProps, setEligiblityDialogProps] = useState<any>({
		openDialog: false,
		handleCloseEligiblityDialog: () =>
			setEligiblityDialogProps(
				Object.assign({}, eligiblityDialogProps, {
					openDialog: false
				})
			),
		eligibleDependents: [],
		ineligibleDependents: [],
		ineligibleRelationshipDependents: [],
		VEBPlanName: "Critical Illness"
	});
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

	const [emailDisclaimer, setEmailDisclaimer] = useState("");
	const [hasReadTC, setHasReadTC] = useState(false);
	const [isActivelyWorking, setIsActivelyWorking] = useState(false);

	const [employeeEnrollment, setEmployeeEnrollment] = useState<any>();
	const [childrenEnrollment, setChildrenEnrollment] = useState<any>();
	const [spouseEnrollment, setSpouseEnrollment] = useState<any>();

	const [enrollmentDependencyDialogProps, setEnrollmentDependencyDialogProps] = useState({
		openDialog: false,
		content: DEPENDENCY_MESSAGE.critical_illness,
		actions: [
			{
				label: "Proceed without Without Cancer coverage level",
				name: "cancel",
				callback: () => {
					setEnrollmentDependencyDialogProps(
						Object.assign({}, enrollmentDependencyDialogProps, { openDialog: false })
					);
				}
			},
			{
				label: "Waive Cancer Plan",
				name: "Waive Cancer Plan",
				callback: () => {
					setEnrollmentDependencyDialogProps(
						Object.assign({}, enrollmentDependencyDialogProps, { openDialog: false })
					);
					history.push("?step=Cancer&stage=1&from=Critical Illness");
				}
			}
		]
	});
	const [criticalIllnessPlanDetails, setCriticalIllnessPlanDetails] = useState<CriticalIllnessPlanDetails>({
		benefit_amount: [10000, 20000, 30000],
		coverage: ["Employee Only", "Employee & Spouse", "Employee & Children", "Employee & Family"],
		coverage_level: ["Without Cancer"],
		premium_amount: {
			standard_premium: {
				"Employee Only": {
					"Without Cancer": {
						10000.0: {
							"18-39": {
								WEEKLY: 0.66,
								MONTHLY: 2.86
							},
							"40-59": {
								WEEKLY: 3.03,
								MONTHLY: 13.13
							},
							"60-64": {
								WEEKLY: 5.13,
								MONTHLY: 22.23
							},
							"65+": {
								WEEKLY: 8.47,
								MONTHLY: 36.7
							}
						},
						20000.0: {
							"18-39": {
								WEEKLY: 1.03,
								MONTHLY: 4.46
							},
							"40-59": {
								WEEKLY: 5.71,
								MONTHLY: 24.74
							},
							"60-64": {
								WEEKLY: 9.92,
								MONTHLY: 42.99
							},
							"65+": {
								WEEKLY: 16.59,
								MONTHLY: 71.89
							}
						},
						30000.0: {
							"18-39": {
								WEEKLY: 1.4,
								MONTHLY: 6.07
							},
							"40-59": {
								WEEKLY: 8.4,
								MONTHLY: 36.4
							},
							"60-64": {
								WEEKLY: 14.71,
								MONTHLY: 63.74
							},
							"65+": {
								WEEKLY: 24.71,
								MONTHLY: 107.08
							}
						}
					},
					"With Cancer": {
						10000.0: {
							"18-39": {
								WEEKLY: 1.12,
								MONTHLY: 4.85
							},
							"40-59": {
								WEEKLY: 5.71,
								MONTHLY: 24.74
							},
							"60-64": {
								WEEKLY: 9.75,
								MONTHLY: 42.25
							},
							"65+": {
								WEEKLY: 15.05,
								MONTHLY: 65.22
							}
						},
						20000.0: {
							"18-39": {
								WEEKLY: 1.94,
								MONTHLY: 8.41
							},
							"40-59": {
								WEEKLY: 11.07,
								MONTHLY: 47.97
							},
							"60-64": {
								WEEKLY: 19.16,
								MONTHLY: 83.03
							},
							"65+": {
								WEEKLY: 29.75,
								MONTHLY: 128.92
							}
						},
						30000.0: {
							"18-39": {
								WEEKLY: 2.77,
								MONTHLY: 12
							},
							"40-59": {
								WEEKLY: 16.44,
								MONTHLY: 71.24
							},
							"60-64": {
								WEEKLY: 28.57,
								MONTHLY: 123.8
							},
							"65+": {
								WEEKLY: 44.46,
								MONTHLY: 192.66
							}
						}
					}
				},
				"Employee & Family": {
					"Without Cancer": {
						10000.0: {
							"18-39": {
								WEEKLY: 1.52,
								MONTHLY: 6.59
							},
							"40-59": {
								WEEKLY: 6.17,
								MONTHLY: 26.74
							},
							"60-64": {
								WEEKLY: 10.3,
								MONTHLY: 44.63
							},
							"65+": {
								WEEKLY: 16.03,
								MONTHLY: 69.46
							}
						},
						20000.0: {
							"18-39": {
								WEEKLY: 2.31,
								MONTHLY: 10.01
							},
							"40-59": {
								WEEKLY: 11.52,
								MONTHLY: 49.92
							},
							"60-64": {
								WEEKLY: 19.77,
								MONTHLY: 85.67
							},
							"65+": {
								WEEKLY: 31.22,
								MONTHLY: 135.29
							}
						},
						30000.0: {
							"18-39": {
								WEEKLY: 3.1,
								MONTHLY: 13.43
							},
							"40-59": {
								WEEKLY: 16.86,
								MONTHLY: 73.06
							},
							"60-64": {
								WEEKLY: 29.24,
								MONTHLY: 126.71
							},
							"65+": {
								WEEKLY: 46.42,
								MONTHLY: 201.15
							}
						}
					},
					"With Cancer": {
						10000.0: {
							"18-39": {
								WEEKLY: 2.46,
								MONTHLY: 10.66
							},
							"40-59": {
								WEEKLY: 11.15,
								MONTHLY: 48.32
							},
							"60-64": {
								WEEKLY: 19.16,
								MONTHLY: 83.03
							},
							"65+": {
								WEEKLY: 28.37,
								MONTHLY: 122.94
							}
						},
						20000.0: {
							"18-39": {
								WEEKLY: 4.18,
								MONTHLY: 18.11
							},
							"40-59": {
								WEEKLY: 21.47,
								MONTHLY: 93.04
							},
							"60-64": {
								WEEKLY: 37.48,
								MONTHLY: 162.41
							},
							"65+": {
								WEEKLY: 55.9,
								MONTHLY: 242.23
							}
						},
						30000.0: {
							"18-39": {
								WEEKLY: 5.91,
								MONTHLY: 25.61
							},
							"40-59": {
								WEEKLY: 31.79,
								MONTHLY: 137.76
							},
							"60-64": {
								WEEKLY: 55.81,
								MONTHLY: 241.84
							},
							"65+": {
								WEEKLY: 83.44,
								MONTHLY: 361.57
							}
						}
					}
				},
				"Employee & Children": {
					"Without Cancer": {
						10000.0: {
							"18-39": {
								WEEKLY: 1.52,
								MONTHLY: 6.59
							},
							"40-59": {
								WEEKLY: 6.17,
								MONTHLY: 26.74
							},
							"60-64": {
								WEEKLY: 10.3,
								MONTHLY: 44.63
							},
							"65+": {
								WEEKLY: 16.03,
								MONTHLY: 69.46
							}
						},
						20000.0: {
							"18-39": {
								WEEKLY: 2.31,
								MONTHLY: 10.01
							},
							"40-59": {
								WEEKLY: 11.52,
								MONTHLY: 49.92
							},
							"60-64": {
								WEEKLY: 19.77,
								MONTHLY: 85.67
							},
							"65+": {
								WEEKLY: 31.22,
								MONTHLY: 135.29
							}
						},
						30000.0: {
							"18-39": {
								WEEKLY: 3.1,
								MONTHLY: 13.43
							},
							"40-59": {
								WEEKLY: 16.86,
								MONTHLY: 73.06
							},
							"60-64": {
								WEEKLY: 29.24,
								MONTHLY: 126.71
							},
							"65+": {
								WEEKLY: 46.42,
								MONTHLY: 201.15
							}
						}
					},
					"With Cancer": {
						10000.0: {
							"18-39": {
								WEEKLY: 2.46,
								MONTHLY: 10.66
							},
							"40-59": {
								WEEKLY: 11.15,
								MONTHLY: 48.32
							},
							"60-64": {
								WEEKLY: 19.16,
								MONTHLY: 83.03
							},
							"65+": {
								WEEKLY: 28.37,
								MONTHLY: 122.94
							}
						},
						20000.0: {
							"18-39": {
								WEEKLY: 4.18,
								MONTHLY: 18.11
							},
							"40-59": {
								WEEKLY: 21.47,
								MONTHLY: 93.04
							},
							"60-64": {
								WEEKLY: 37.48,
								MONTHLY: 162.41
							},
							"65+": {
								WEEKLY: 55.9,
								MONTHLY: 242.23
							}
						},
						30000.0: {
							"18-39": {
								WEEKLY: 5.91,
								MONTHLY: 25.61
							},
							"40-59": {
								WEEKLY: 31.79,
								MONTHLY: 137.76
							},
							"60-64": {
								WEEKLY: 55.81,
								MONTHLY: 241.84
							},
							"65+": {
								WEEKLY: 83.44,
								MONTHLY: 361.57
							}
						}
					}
				},
				"Employee & Spouse": {
					"Without Cancer": {
						10000.0: {
							"18-39": {
								WEEKLY: 1.52,
								MONTHLY: 6.59
							},
							"40-59": {
								WEEKLY: 6.17,
								MONTHLY: 26.74
							},
							"60-64": {
								WEEKLY: 10.3,
								MONTHLY: 44.63
							},
							"65+": {
								WEEKLY: 16.03,
								MONTHLY: 69.46
							}
						},
						20000.0: {
							"18-39": {
								WEEKLY: 2.31,
								MONTHLY: 10.01
							},
							"40-59": {
								WEEKLY: 11.52,
								MONTHLY: 49.92
							},
							"60-64": {
								WEEKLY: 19.77,
								MONTHLY: 85.67
							},
							"65+": {
								WEEKLY: 31.22,
								MONTHLY: 135.29
							}
						},
						30000.0: {
							"18-39": {
								WEEKLY: 3.1,
								MONTHLY: 13.43
							},
							"40-59": {
								WEEKLY: 16.86,
								MONTHLY: 73.06
							},
							"60-64": {
								WEEKLY: 29.24,
								MONTHLY: 126.71
							},
							"65+": {
								WEEKLY: 46.42,
								MONTHLY: 201.15
							}
						}
					},
					"With Cancer": {
						10000.0: {
							"18-39": {
								WEEKLY: 2.46,
								MONTHLY: 10.66
							},
							"40-59": {
								WEEKLY: 11.15,
								MONTHLY: 48.32
							},
							"60-64": {
								WEEKLY: 19.16,
								MONTHLY: 83.03
							},
							"65+": {
								WEEKLY: 28.37,
								MONTHLY: 122.94
							}
						},
						20000.0: {
							"18-39": {
								WEEKLY: 4.18,
								MONTHLY: 18.11
							},
							"40-59": {
								WEEKLY: 21.47,
								MONTHLY: 93.04
							},
							"60-64": {
								WEEKLY: 37.48,
								MONTHLY: 162.41
							},
							"65+": {
								WEEKLY: 55.9,
								MONTHLY: 242.23
							}
						},
						30000.0: {
							"18-39": {
								WEEKLY: 5.91,
								MONTHLY: 25.61
							},
							"40-59": {
								WEEKLY: 31.79,
								MONTHLY: 137.76
							},
							"60-64": {
								WEEKLY: 55.81,
								MONTHLY: 241.84
							},
							"65+": {
								WEEKLY: 83.44,
								MONTHLY: 361.57
							}
						}
					}
				}
			}
		}
	});
	const [eligibleDependents, setEligibleDependents] = useState<Member[]>([]);

	const [standardPremium, setStandardPremium] = useState(0.0);
	const [hasCancerEnrollment, setHasCancerEnrollment] = useState<null | boolean>(null);
	const [criticalIllnessPlanInputs, setCriticalIllnessPlanInputs] = useState<{
		coverage: null | string;
		coverage_level: null | "With Cancer" | "Without Cancer";
		benefit_amount: null | number;
	}>({
		coverage: null,
		coverage_level: null,
		benefit_amount: null
	});
	const [planCode, setPlanCode] = useState<string>();
	const [VEBOpenEnrollmentId, setVEBOpenEnrollmentId] = useState<string>();
	const [criticalIllnessPlan, setCriticalIllnessPlan] = useState<VEBPlan>({
		_id: "",
		plan_name: "",
		plan_code: "",
		start_date: null,
		end_date: null,
		status: ""
	});
	const { theme } = useContext(ThemeContext);
	const [spouse, setSpouse] = useState<Member>();
	const { member } = useContext(AuthContext);
	const { dependents } = useContext(DependentsContext);
	const { eligiblity, setEligiblity } = useContext(EligibleDependentContext);
	const { paycheck } = useContext(PaycheckContext);
	const { setCurrentEnrollment, deleteCurrentEnrollment } = useContext(EnrollmentContext);
	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();

	const [enrollmentDisclaimerDialogProps, setEnrollmentDisclaimerDialogProps] =
		useState<CustomDisclaimerDialogPropsType>({
			openDialog: false,
			title: "Disclaimer",
			content:
				"Critical Illness: I hereby apply to Reserve National Insurance Company for insurance coverage to be issued solely and entirely in reliance upon the written answers to the foregoing questions and/or information obtained by the Company in its underwriting process. I agree and understand that no insurance coverage will be in force until the effective date specified by the Company. I represent that no person to be covered under the terms of the certificate being applied for is also covered by Medicaid or any similar program. I have read or had read to me all the questions and answers in this application and such answers to the best of my (our) knowledge and belief are true and complete. I understand and agree that any falsity of any answer or statement in this application which materially affects the acceptance of the risk or hazard assumed by the Company may bar the right to recovery under any certificate issued. FRAUD WARNING:Any person who, with intent to defraud or knowing that he/she is facilitating a fraud against an insurer,submits an application or files a claim containing a false or deceptive statement may be guilty ofinsurance fraud.",
			importantTitle: "IMPORTANT",
			importantContent:
				"If an individual is insured under this policy and is also covered by Medicaid or a state variation of Medicaid, most non-disability benefits are automatically assigned according to state regulations.  This means that instead of paying the benefits to the insured individual, we must pay the benefits to Medicaid or the medical provider to reduce the charges billed to Medicaid.  Please consider your circumstances before enrolling in MedMutual Protect Benefits coverage.",
			inputFields: [
				{
					name: "Email Discalimer",
					value: emailDisclaimer,
					placeholder: "Enter Email"
				}
			],
			actions: [
				{
					label: "Email Disclaimer",
					callback: () => {
						null;
						// setEnrollmentDisclaimerDialogProps(
						// 	Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false })
						// );
					}
				}
			]
		});

	const getVEBPlanCode = useCallback((VEBOpenEnrollment: any[]) => {
		// console.log("**********VEBOpenEnrollment********", VEBOpenEnrollment[0]);
		let _planCode, _VEBOpenEnrollmentId;
		for (let idx = 0; idx < VEBOpenEnrollment.length; idx++) {
			const planName = VEBOpenEnrollment[idx].open_enrollment.veb_plan_name;
			const planCode = VEBOpenEnrollment[idx].open_enrollment.veb_plan_code;
			const VEBPlanId = VEBOpenEnrollment[idx].open_enrollment.veb_plan_id;
			const VEBOpenEnrollmentId = VEBOpenEnrollment[idx].VEB_open_enrollment_id;
			// console.log("<====Plan Name===>", planName);

			if (planName === VEB_PLAN_NAMES.critical_illness) {
				_planCode = planCode;
				_VEBOpenEnrollmentId = VEBOpenEnrollmentId;

				const _planPaylaod = {
					_id: VEBPlanId,
					plan_name: planName,
					plan_code: _planCode,
					start_date: null,
					end_date: null,
					status: "ACTIVE"
				};

				setCriticalIllnessPlan(Object.assign({}, _planPaylaod));
			}
		}

		setPlanCode(_planCode);
		setVEBOpenEnrollmentId(_VEBOpenEnrollmentId);
	}, []);

	//End BV2 State

	const handlePlanInputChange = useCallback(
		(event: SelectChangeEvent<unknown>, child: React.ReactNode) => {
			const { name, value } = event.target;
			// console.log(name, value, "coverage for");
			setCriticalIllnessPlanInputs(
				Object.assign({}, criticalIllnessPlanInputs, {
					[name]: value
				})
			);
		},
		[criticalIllnessPlanInputs]
	);

	const calculatePremium = useCallback(() => {
		const { coverage, coverage_level, benefit_amount } = criticalIllnessPlanInputs;
		// console.log("yes premium calculating");
		if (
			paycheck !== null &&
			coverage !== null &&
			coverage_level !== null &&
			coverage_level !== null &&
			benefit_amount !== null &&
			member?.date_of_birth
		) {
			if (benefit_amount == 0) {
				setStandardPremium(0);
				setCurrentEnrollment(
					Object.assign(
						{},
						{
							plan_name: "Critical Illness",
							status: "Current",
							premium_amount: Number(0)
						}
					)
				);
				return;
			}
			const ageGroup = calculateAgeGroup(calculateAge(member.date_of_birth as any, new Date()));
			// console.log(
			// 	"ageGroup",
			// 	coverage,
			// 	VEB_TO_GENERAL_COVERAGE_CODE[coverage as keyof typeof VEB_TO_GENERAL_COVERAGE_CODE],
			// 	CRITICAL_ILLNESS_PREMIUM.premium_amount.standard_premium[
			// 		VEB_TO_GENERAL_COVERAGE_CODE[
			// 			coverage as keyof typeof VEB_TO_GENERAL_COVERAGE_CODE
			// 		] as keyof CriticalIllnessPlanCoverage
			// 	]
			// );
			const _standardPremium =
				CRITICAL_ILLNESS_PREMIUM.premium_amount.standard_premium[coverage as keyof CriticalIllnessPlanCoverage][
					coverage_level as keyof CriticalIllnessCoverageLevel
				][benefit_amount as keyof CriticalIllnessBenefitLevel][ageGroup as keyof CriticalIllnessAgeGroups][
					paycheck.pay_frequency as keyof PaycheckFrequency
				];
			setStandardPremium(_standardPremium);
			setCurrentEnrollment(
				Object.assign(
					{},
					{
						plan_name: "Critical Illness",
						status: "Current",
						premium_amount: Number(_standardPremium.toFixed(2))
					}
				)
			);
		}
	}, [criticalIllnessPlanInputs, member.date_of_birth, paycheck, setCurrentEnrollment]);

	const handleValidation = useCallback((): boolean => {
		const { coverage, coverage_level } = criticalIllnessPlanInputs;
		if (coverage === null || coverage_level === null) {
			alert("Please fill all required fields");
			return false;
		}
		if (
			criticalIllnessPlanInputs.benefit_amount == null ||
			criticalIllnessPlanInputs.benefit_amount == 0 ||
			!criticalIllnessPlanInputs.benefit_amount
		) {
			return true;
		}
		if (hasReadTC === false) {
			alert("Please agree to the Disclaimer");
			return false;
		}
		if (isActivelyWorking === false) {
			alert("You must actively working 20 hours or more to enroll");
			return false;
		}
		return true;
	}, [criticalIllnessPlanInputs, hasReadTC, isActivelyWorking]);

	const handleActivateButtonClick = useCallback(async () => {
		const isValid = handleValidation();
		// console.log("isValid", isValid);
		// console.log("criticalIllnessPlan", criticalIllnessPlan);
		if (isValid === false) {
			return;
		}
		if (member && criticalIllnessPlanInputs.coverage && criticalIllnessPlan && VEBOpenEnrollment && paycheck) {
			const increased_benefit_amount =
				criticalIllnessPlanInputs.benefit_amount == null || criticalIllnessPlanInputs.benefit_amount == 0
					? 0
					: criticalIllnessPlanInputs.benefit_amount;
			const stack_enrollment: any = {}; // Initialize main object

			const veb_open_enrollment: any = VEBOpenEnrollment?.filter(
				(veb_open_enrollment: any) =>
					veb_open_enrollment.open_enrollment.veb_plan_name == VEB_PLAN_NAMES.critical_illness
			);

			const coverage_code = vebBenefits.map((benefit: any) => benefit.coverage_code);

			stack_enrollment["_id"] = employeeEnrollment[0]._id;
			stack_enrollment["increased_benefit_amount"] = increased_benefit_amount;
			stack_enrollment["top_up_standard_premium"] = Number(standardPremium.toFixed(2));
			stack_enrollment["top_up_total_premium"] = Number(standardPremium.toFixed(2));
			stack_enrollment["veb_open_enrollment_id"] = veb_open_enrollment[0]?.VEB_open_enrollment_id;

			stack_enrollment["common_details"] = {
				plan: criticalIllnessPlan,
				coverage_code: coverage_code,
				veb_plan_name: VEB_PLAN_NAMES.critical_illness,
				effective_date: VEBPlanCodes2024.includes(criticalIllnessPlan.plan_code as unknown as string)
					? VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD
					: VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_YYYYMMDD,
				veb_plan_code: veb_open_enrollment[0]?.open_enrollment.veb_plan_code,
				veb_open_enrollment_id: veb_open_enrollment[0]?.VEB_open_enrollment_id,
				open_enrollment_for: veb_open_enrollment[0].open_enrollment.open_enrollment_for,
				employee_SSN: veb_open_enrollment[0]?.employee_SSN
				// is_rider: hasSelectedRider ? true : false
			};

			// console.log("criticalIllnessPlanInputs", criticalIllnessPlanInputs);

			const standardResponse = await trackPromise(
				api.enrollment.stackCriticalIllnessEnrollment(stack_enrollment)
			);
			if (standardResponse) {
				getVEBEnrollmentInitData();
				const step = urlSearchParams.get("step");
				const from = urlSearchParams.get("from");
				if (from === "Cancer") {
					alert(`Succesfully enrolled for Critical Illness with ${criticalIllnessPlanInputs.coverage_level}`);
				}
				if (increased_benefit_amount == null || increased_benefit_amount == 0) {
					history.push(`?step=${step}&stage=0`);
					onClose();
				} else {
					history.push(`?step=${step}&stage=2`);
					onClose();
				}
			}
		}
	}, [
		VEBOpenEnrollment,
		criticalIllnessPlan,
		criticalIllnessPlanInputs.benefit_amount,
		criticalIllnessPlanInputs.coverage,
		criticalIllnessPlanInputs.coverage_level,
		employeeEnrollment,
		getVEBEnrollmentInitData,
		handleValidation,
		history,
		member,
		onClose,
		paycheck,
		standardPremium,
		urlSearchParams,
		vebBenefits
	]);

	const handleAgreedTCCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setHasReadTC(checked);
	};

	const handleIsActivelyWorkingCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setIsActivelyWorking(checked);
	};

	// const getCancerEnrollment = useCallback(async () => {
	// 	const cancerEnrollment: VEBEnrollmentSchema | null = await trackPromise(api.enrollment.getCancerEnrollment());
	// 	if (cancerEnrollment) {
	// 		setHasCancerEnrollment(true);
	// 		setEnrollmentDependencyDialogProps(
	// 			Object.assign({}, enrollmentDependencyDialogProps, { openDialog: true })
	// 		);
	// 		// alert(
	// 		// 	"You are ineligible for Critical Illness With Cancer Plan Coverage level since you have already enrolled for Cancer Plan!!\n\nIf you want to enroll for Critical Illness With Cancer coverage level please waive Cancer Plan"
	// 		// );
	// 	} else {
	// 		setHasCancerEnrollment(false);
	// 		setCriticalIllnessPlanDetails((prevCriticalIllnessPlanDetails: CriticalIllnessPlanDetails) => {
	// 			return Object.assign({}, prevCriticalIllnessPlanDetails, {
	// 				coverage_level: ["With Cancer", ...prevCriticalIllnessPlanDetails.coverage_level]
	// 			});
	// 		});
	// 	}
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, []);

	const handleCloseDisclaimerDialog = useCallback(() => {
		setEnrollmentDisclaimerDialogProps(Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false }));
	}, [enrollmentDisclaimerDialogProps]);

	const handleEscapeCloseDisclaimerDialog = useCallback(
		(event: React.KeyboardEvent<HTMLInputElement | HTMLDivElement>) => {
			const Key = event.key;

			if (Key === "Escape")
				setEnrollmentDisclaimerDialogProps(
					Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false })
				);
		},
		[enrollmentDisclaimerDialogProps]
	);

	const handleOpenDisclaimerDialogClick = useCallback(
		(event: React.MouseEvent<HTMLSpanElement>) => {
			setEnrollmentDisclaimerDialogProps(
				Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: true })
			);
		},
		[enrollmentDisclaimerDialogProps]
	);

	useEffect(() => {
		if (vebBenefits && vebBenefits.length > 0) {
			const coverage_code = vebBenefits.map((benefit: any) => benefit.coverage_code);
			const employeeEnrollment = vebBenefits.filter((benefit: any) => benefit.insured_SSN == benefit.member_SSN);
			const spouseEnrollment = vebBenefits.filter((benefit: any) => benefit["member"].relationship == "SPOUSE");
			const childrenEnrollment = vebBenefits.filter(
				(benefit: any) =>
					benefit["member"].relationship == "CHILD" ||
					benefit["member"].relationship == "STEP CHILD" ||
					benefit["member"].relationship == "GRANDCHILD" ||
					benefit["member"].relationship == "LEGAL CUSTODY CHILD" ||
					benefit["member"].relationship == "COURT-ORDERED DEPENDENT" ||
					benefit["member"].relationship == "DISABLED CHILD"
			);

			const coverageCodeConstant: any = {
				EE: "Employee Only",
				ES: "Employee & Spouse",
				ED: "Employee & Dependents",
				EF: "Employee & Family"
			};
			setCriticalIllnessPlanInputs(
				Object.assign({}, criticalIllnessPlanInputs, {
					coverage: coverageCodeConstant[coverage_code[0]],
					coverage_level: employeeEnrollment[0].sub_plan
				})
			);
			setEmployeeEnrollment(employeeEnrollment);

			setSpouseEnrollment(spouseEnrollment);
			setChildrenEnrollment(childrenEnrollment);
		}
	}, [vebBenefits]);

	useEffect(() => {
		calculatePremium();
	}, [
		calculatePremium,
		criticalIllnessPlanInputs.coverage,
		criticalIllnessPlanInputs.coverage_level,
		criticalIllnessPlanInputs.benefit_amount
	]);

	useEffect(() => {
		// getCancerEnrollment();
		const dependentCoverage = getKemperCriticalIllnessEligibleDependents(dependents);

		setEligibleDependents(Object.assign([], dependentCoverage.dependents));
		setCriticalIllnessPlanDetails((prevCancerPlanDetails: CriticalIllnessPlanDetails) => {
			return Object.assign({}, prevCancerPlanDetails, {
				coverage: dependentCoverage.coverage
			});
		});
		const _spouse = dependentCoverage.dependents.find((dependent: Member) => dependent.relationship === "SPOUSE");
		if (_spouse) {
			setSpouse(Object.assign({}, _spouse));
		}
	}, [dependents, setEligiblity]);

	useEffect(() => {
		if (VEBOpenEnrollment && VEBOpenEnrollment.length !== 0) {
			getVEBPlanCode(VEBOpenEnrollment);
		}
	}, [VEBOpenEnrollment, getVEBPlanCode]);

	return (
		<>
			<Suspense fallback={<div />}>
				<CustomEnrollmentDisclaimerDialog
					enrollmentDisclaimerDialogProps={enrollmentDisclaimerDialogProps}
					handleCloseDisclaimerDialog={handleCloseDisclaimerDialog}
					handleEscapeCloseDisclaimerDialog={handleEscapeCloseDisclaimerDialog}
					emailDisclaimer={emailDisclaimer}
					setEmailDisclaimer={setEmailDisclaimer}
				/>
				<Suspense fallback={<div />}>
					{customFormDialogProps ? (
						<LazyCustomFormDialog customFormDialogProps={customFormDialogProps} />
					) : null}
				</Suspense>
				<div className="kemper-cancer-form plan-form">
					<div className="paper-form-container" style={{ padding: "0" }}>
						<Paper className="theme-border-radius paper-container" elevation={1}>
							<div className="plan-content">
								<div className="theme-plan-section-margin" />
								<div className="header-container">
									<div className="theme-plan-header">Stack Benefits</div>
									<div
										className="theme-plan-sub-header plan-text"
										style={{ borderLeftColor: theme.primary_color }}
									>
										In addition to yourself, who would you like to cover under this plan?
									</div>
								</div>
								<Grid className="grid-container" container columnSpacing={2}>
									<Grid item xl={4} lg={4} md={4} sm={4} xs={6}>
										<div className="details-form-row">
											<div className="details-form-label  required">Coverage Level</div>
											{employeeEnrollment && employeeEnrollment.length > 0 && (
												<TextField
													className="current-benefit-amounts"
													value={employeeEnrollment[0].sub_plan}
													// InputProps={{
													// 	startAdornment: <Block />, // <== adjusted this
													// 	disableUnderline: true // <== added this
													// }}
													disabled
												>
													{employeeEnrollment[0].sub_plan}
												</TextField>
											)}
										</div>
									</Grid>
									<Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
										<div className="details-form-row">
											<div className="details-form-label  required">Coverage For</div>

											{criticalIllnessPlanInputs.coverage && (
												<TextField
													className="current-benefit-amounts"
													value={criticalIllnessPlanInputs.coverage}
													// InputProps={{
													// 	startAdornment: <Block />, // <== adjusted this
													// 	disableUnderline: true // <== added this
													// }}
													disabled
												>
													{criticalIllnessPlanInputs.coverage}
												</TextField>
											)}
										</div>
									</Grid>
									<Grid item xl={2} lg={2} md={2} sm={2} xs={0}></Grid>

									<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
										<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
											<div className="details-form-row">
												<div className="details-form-label  required">
													Current Benefit Amount
												</div>
												{employeeEnrollment && employeeEnrollment.length > 0 && (
													<TextField
														className="current-benefit-amounts"
														value={employeeEnrollment[0].benefit_amount}
														// InputProps={{
														// 	startAdornment: <Block />, // <== adjusted this
														// 	disableUnderline: true // <== added this
														// }}
														disabled
													>
														{employeeEnrollment[0].benefit_amount}
													</TextField>
												)}
											</div>
										</Grid>
										<Grid item xl={2} lg={2} md={2} sm={2} xs={6} className="amount-middle">
											<div className="details-form-row">
												<div className="details-form-label align-center">Current Premium</div>

												{employeeEnrollment && employeeEnrollment.length > 0 && (
													<div className="show-premium">
														{dollarize(employeeEnrollment[0].total_premium)}
													</div>
												)}
											</div>
										</Grid>
										<Grid item xl={5} lg={5} md={5} sm={5} xs={0} />
									</Grid>
									<Grid className="grid-container" container columnSpacing={2}>
										<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
											<div className="details-form-row">
												<div className="details-form-label  required">Benefit Amount</div>
												{employeeEnrollment && employeeEnrollment.length > 0 && (
													<Select
														input={<CustomSelectInput />}
														style={{ width: "100%" }}
														name="benefit_amount"
														onChange={handlePlanInputChange}
													>
														<MenuItem value={0}>0</MenuItem>
														{criticalIllnessPlanDetails.benefit_amount
															.filter(
																(item, index) =>
																	item &&
																	item <=
																		Number(
																			30000 - employeeEnrollment[0].benefit_amount
																		)
															)
															.map((amount: number, index: number) => {
																return (
																	<MenuItem key={index} value={amount}>
																		{dollarize(amount)}
																	</MenuItem>
																);
															})}
													</Select>
												)}
											</div>
										</Grid>
										<Grid item xl={4} lg={4} md={4} sm={4} xs={0} />
										<Grid item xl={3} lg={3} md={3} sm={3} xs={6} className="amount-middle">
											<div className="details-form-row">
												<div className="details-form-label align-center">
													Total Top Up Premium
												</div>
												<div className="show-premium">{dollarize(standardPremium)}</div>
											</div>
										</Grid>
									</Grid>
								</Grid>

								<div className="theme-plan-inner-section-margin" />
								<Grid container className="theme-plan-inner-section-margin">
									<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
										<div className="details-form-row">
											<div
												className="details-form-label theme-plan-total-premium align-right"
												style={{ color: theme.primary_color }}
											>
												Total Premium:{" "}
												<span className="show-premium margin-adjust">
													{employeeEnrollment && employeeEnrollment.length > 0
														? dollarize(
																Number(
																	(
																		Number(standardPremium) +
																		Number(employeeEnrollment[0].total_premium)
																	).toFixed(2)
																)
														  )
														: dollarize(standardPremium)}
												</span>
											</div>
										</div>
									</Grid>
								</Grid>
							</div>

							{!VEBPlanCodes2024.includes(planCode as unknown as string) ? (
								<div className="veb-disclaimer">
									<VEBDisclaimer />
								</div>
							) : null}
							<div className="theme-plan-option-content">
								<Checkbox
									checked={isActivelyWorking}
									style={{ paddingLeft: 0 }}
									onChange={handleIsActivelyWorkingCheckboxChange}
								/>
								<p className="theme-plan-checkbox-label">
									<strong>Are you actively at work 20 or more hours per week?</strong>
								</p>
							</div>
							<div>
								<div className="theme-plan-option-content">
									<Checkbox
										checked={hasReadTC}
										style={{ paddingLeft: 0 }}
										onChange={handleAgreedTCCheckboxChange}
									/>
									<p className="theme-plan-checkbox-label">
										<strong>
											I have read the{" "}
											<span
												className="veb-plan-disclaimer"
												style={{ color: theme.primary_color }}
												onClick={handleOpenDisclaimerDialogClick}
											>
												Disclaimer
											</span>
										</strong>
									</p>
								</div>
							</div>

							<div className="theme-plan-inner-section-margin-2" />
							<LazyPlanActions
								waiveButtonCallback={null}
								activateButtonCallback={handleActivateButtonClick}
							/>
						</Paper>
					</div>
				</div>
			</Suspense>
		</>
	);
};

export default KemperStackFormCriticalIllness;
